@if (isProjectEmpty()) {
  <div
    class="no-visualisation"
    [class.no-visualisation-new]="user.isPremium"
    >
    @if (!isMobile) {
      <div class="content">
        <h2>
          {{ 'empty_project_header' | translate }}
        </h2>
        @if (!whiteLabel.logoUrl) {
          <p [innerHTML]="'empty_project_message' | translate"></p>
        }
        @if (whiteLabel.logoUrl) {
          <p [innerHTML]="'empty_project_message_wl' | translate"></p>
        }
      </div>
    }
    @if (isMobile) {
      <div class="content" [class.contentMobile]="isMobile">
        <h2>{{ 'empty_project_header' | translate }}</h2>
        <p [innerHTML]="'empty_project_message_mobile' | translate"></p>
      </div>
    }
  </div>
}
<div class="visualisation-container" #visualisationContainer></div>
@if (visualisation && !isProjectEmpty() && !isMobile) {
  <button
    icon-button
    class="reset-view"
    (click)="resetView()"
    >
    <gl-icon [name]="'eye'"></gl-icon>
  </button>
}

@if (isMobile && visualisation && !isProjectEmpty()) {
  <div
    class="order-view"
    [class.order-view-mobile]="isMobile"
    >
    <div class="order-view-container">
      <button
        [disabled]="currentObserver === undefined || currentObserver === null"
        icon-button
        (click)="previousOrderGroup()"
        >
        <gl-icon
          class="order-icon previous-icon"
          [class.disabled-icon]="currentObserver === undefined || currentObserver === null"
          [name]="'next'"
        ></gl-icon>
      </button>
      @if (!startedOrdedView) {
        <button icon-button (click)="startOrderView()">
          <gl-icon class="order-icon" [name]="'play'"></gl-icon>
        </button>
      }
      @if (startedOrdedView) {
        <button icon-button (click)="stopOrderView()">
          <gl-icon class="order-icon" [name]="'pause'"></gl-icon>
        </button>
      }
      <button
        [disabled]="currentObserver === undefined && !startedOrdedView"
        icon-button
        (click)="nextOrderGroup()"
        >
        <gl-icon
          class="order-icon"
          [class.disabled-icon]="currentObserver === undefined && !startedOrdedView"
          [name]="'next'"
        ></gl-icon>
      </button>
    </div>
    @if (currentObserver !== undefined && currentGroup) {
      <div class="current-group">
        <img [src]="getIconDataUrl()" alt="" />
        <div class="current-group-name">
          <h3>
            {{ currentGroup.name | translate }}
          </h3>
          <p>
            {{ currentGroup.dimensions.length }}x{{ currentGroup.dimensions.width }}x{{
            currentGroup.dimensions.height | unit: 'length':false
            }}
            | {{ currentGroup.weight | unit: 'weight':false }}
          </p>
        </div>
      </div>
    }
  </div>
}

@if (isMobile) {
  <div class="mobileView">
    <img class="mobileLogo" src="/assets/svg/logo-color-with-text.svg" />
    <p class="mobileDescription">{{ 'change_view_on_mobile' | translate }}</p>
  </div>
}
@if (rightClickedLoad) {
  <gl-load-context-menu
    [load]="rightClickedLoad"
    [loadOriginal]="rightClickedLoadOriginal"
    glContextMenu
    [mousePosition]="mousePosition"
    [boundaryHeight]="getHeight()"
    [boundaryWidth]="getWidth()"
    [visualisation]="visualisation"
    (glMousedownOutside)="closeContextMenu()"
    (changeFloorAction)="changeFloorAction()"
    (closeContextMenu)="closeContextMenuEmit($event)"
  ></gl-load-context-menu>
}
@if (isHint) {
  <gl-hint
    [mousePosition]="mousePosition"
    [boundaryHeight]="getHeight()"
    [boundaryWidth]="getWidth()"
    (closeHint)="closeLoadHint()"
    [message]="hoveredLoadName"
    [isNearCursor]="true"
    [showUnit]="false"
    [unit]="project?.options?.unit"
  ></gl-hint>
}
@if (measurePoint > 0) {
  <gl-hint
    [mousePosition]="mousePosition"
    [boundaryHeight]="getHeight()"
    [boundaryWidth]="getWidth()"
    (closeHint)="closeMeasureHint()"
    [message]="measurePoint.toString()"
    [unit]="project?.options?.unit"
  ></gl-hint>
}
